import { MasterMutationAPI } from '../api/master-mutation-api';
import { PageContext } from '../context/page-context';
import { MasterProps } from '../props/page/master-props';
import { MasterStore } from '../store/master-store';
import { PageDataModel } from './page-data-model';
import type { IEventManager } from '../manager/event-manager';
import type { IShapeDataModel, ShapeDataModel } from './shape-data-model';
import type { ICTPlaceholderPml, ICTTextListStyle, STPlaceholderType } from '@tencent/slide-sdk-pb-model';
import type { IMasterData } from '../data';
import type { IMasterProps } from '../props/page/master-props';
import type { RestrictedDataModel } from './data-model';
import type { ILayoutDataModel } from './layout-data-model';
import type { PresentationDataModel } from './presentation-data-model';
import type { IThemeDataModel } from './theme-data-model';
import type { DeepReadonly } from 'ts-essentials';

export class MasterDataModel extends PageDataModel<IMasterData, IMasterProps> {
    public context: PageContext;
    public store: MasterStore;
    public api: MasterMutationAPI;
    public props: IMasterProps;

    public constructor(data: IMasterData, events: IEventManager, parent: PresentationDataModel) {
        super(events, parent);

        const theme = parent.store.getThemeById(data.themeId);
        if (!theme) {
            throw new Error(`missing theme: ${data.themeId}`);
        }

        this.context = new PageContext(data.type);
        this.context.setPresentation(parent);
        this.context.setMaster(this);
        this.context.setTheme(theme);
        this.context.setPage(this);
        this.context.setTarget(this);

        this.store = new MasterStore(data, events, this.context, this);
        this.props = new MasterProps(this.store.data, this.context);
        this.api = new MasterMutationAPI(this, events);
    }

    public get layoutList(): ILayoutDataModel[] {
        return this.store.layoutList.toArray();
    }

    public getMaster(): IMasterDataModel {
        return this;
    }

    public getTheme(): IThemeDataModel | undefined {
        return this.parent?.store.getThemeById(this.props.themeId);
    }

    public getLayout() {
        return;
    }

    public getPlaceholderShape(ph: DeepReadonly<ICTPlaceholderPml>): IShapeDataModel | undefined {
        return this.store.findPlaceholderShape<ShapeDataModel>(ph);
    }

    public getPlaceholderTxStyle(phType?: STPlaceholderType): DeepReadonly<ICTTextListStyle> | undefined {
        return this.store.findPlaceholderTxStyle(phType);
    }

    public forEachDescendant(callback: (child: RestrictedDataModel) => void = () => void 0) {
        if (this.timing) {
            callback(this.timing);
        }
        super.forEachDescendant(callback);
    }
}

export { IMasterProps };
export type IMasterDataModel = RestrictedDataModel<MasterDataModel>;
